import React from 'react';
import { getWeekDatesRange } from '../WeeklyDateNavigation';
import { getFirstDayInMonth } from './util/dateUtils';
const WeeklyDatePickerContext = React.createContext(undefined);
export const useWeeklyDatePickerContext = () => {
    const context = React.useContext(WeeklyDatePickerContext);
    if (!context) {
        throw new Error('useWeeklyDatePicker must be used within a WeeklyDatePickerProvider.');
    }
    return context;
};
export const WeeklyDatePickerProvider = ({ firstDayOfWeek, selectedDate, onDisplayedWeekChange, children }) => {
    const [currentWeek, setWeek] = React.useState(getWeekDatesRange(selectedDate, firstDayOfWeek));
    const [currentMonth, setMonth] = React.useState(getFirstDayInMonth(currentWeek.startOfWeek));
    const setCurrentWeek = (week, callBack) => {
        setWeek(week);
        callBack?.();
        if (onDisplayedWeekChange) {
            onDisplayedWeekChange(week);
        }
    };
    const setCurrentMonth = (month) => {
        setMonth(getFirstDayInMonth(month));
    };
    return (React.createElement(WeeklyDatePickerContext.Provider, { value: { currentWeek, setCurrentMonth, setCurrentWeek, currentMonth } }, children));
};
//# sourceMappingURL=WeeklyDatePickerProvider.js.map